import useSWR from 'swr'
import {useToken} from "../../../../app/hooks";
import API from "../../../../utils/api";

interface ResponseTypes {
	list: any[];
	total: number;
}

const M_KEY = '/admin/refund/list';

const fetchKey = (page, maxData, searchType, searchWord) =>
	`${M_KEY}?${page && 'page=' + page}${maxData && '&maxData=' + maxData}${searchType && '&searchType=' + searchType}${searchWord && '&searchKeyword=' + searchWord}`;

export function useAdminPaymentReturnList(page, maxData, searchType, searchWord) {
	const { data: token } = useToken();

	const KEY = fetchKey(page, maxData, searchType ?? '', searchWord);


	const fetcher = () => fetchAPI(KEY, token, page, maxData);
	const { data, mutate, isLoading } = useSWR(token ? `${KEY}` : null, fetcher, { revalidateOnFocus: true });

	return { adminPaymentReturnList: data?.list, mutateAdminPaymentReturnList: mutate, total: data?.total, isLoading };
}

const mapStatus = (status?: number | string): string => {
	const code = Number(status);
	if (code === 0) return '환급대기';
	if (code === 1) return '환급완료';
	return '-';
};

function formatAccount(account?: string | null): string {
	if (!account) return '-';
	return account;
}

async function fetchAPI(KEY:string, token:any, page: number, maxData: number): Promise<ResponseTypes> {
	try {
		const response = await API.get(`${KEY}`, token + '', {});
		const list = response.result?.result?.list || [];
		const totalCount = response.result?.result?.totalCount || 0;
		const pageNumber = Number(page) || 1;
		const pageSize = Number(maxData) || list.length || 0;
		const baseIndex = pageSize > 0 ? (pageNumber - 1) * pageSize : 0;
		const mappedList = list.map((item, index) => ({
			...item,
			no: baseIndex + index + 1,
			tel: item?.tel || item?.phone || '-',
			account: formatAccount(item?.account),
			refundAmount: Number(item?.amount ?? 0),
			requestAt: item?.createdAt || '-',
			refundStatus: mapStatus(item?.status),
		}));
		return {list: mappedList, total: totalCount};
	} catch (error) {
		console.error('Failed to fetch Admin Payment Return List:', error);
		return { list: [], total: 0 };
	}
}
